import { Injectable } from "@angular/core";
import { Preferences } from "@capacitor/preferences";

@Injectable({
  providedIn: "root",
})

export class AppstorageTsService {

  constructor() { }


  getMainDomainName() {
    if (window.location.hostname == 'localhost') {
      return 'localhost'
    } else {
      return window.location.hostname.split('.').slice(-2).join('.')
    }
  }

  async setAudioOn(on: boolean) {
    return await Preferences.set({
      key: "audioOn",
      value: on ? "true" : "false",
    });
  }

  async getAudioOn() {
    return await Preferences.get({ key: "audioOn" });
  }

  async setPlayerPlatformID(platformID: any | string) {
    return await Preferences.set({
      key: "platformID",
      value: platformID,
    });
  }

  async removePlayerPlatformID() {
    return await Preferences.remove({
      key: "platformID"
    });
  }

  async getPlayerPlatformID() {
    return await Preferences.get({ key: "platformID" });
  }

  async setPlayerAsGuest(isGuest: boolean) {
    return await Preferences.set({
      key: "isGuestUser",
      value: isGuest ? "true" : "false",
    });
  }

  async getPlayerAsGuest() {
    return await Preferences.get({ key: "isGuestUser" });
  }

  async setPlayerAsSocial(isSocial: boolean) {
    return await Preferences.set({
      key: "isSocialUser",
      value: isSocial ? "true" : "false",
    });
  }

  async getPlayerAsSocial() {
    return await Preferences.get({ key: "isSocialUser" });
  }

  async setPlayerFirstVisit(firstVisit: boolean) {
    return await Preferences.set({
      key: "firstVisit",
      value: firstVisit ? "true" : "false",
    });
  }

  async getPlayerFirstVisit() {
    return await Preferences.get({ key: "firstVisit" });
  }

  async setSkipAskCustomerRotate(isSkip: boolean) {
    return await Preferences.set({
      key: "skip_ask_customer_rotate",
      value: isSkip ? "true" : "false",
    });
  }

  async getSkipAskCustomerRotate() {
    return await Preferences.get({ key: "skip_ask_customer_rotate" });
  }

  async clear() {
    return await Preferences.clear();
  }
}
